import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'home',
            component: () => import('./views/Home.vue')
        },
        {
            path: '/faq',
            name: 'cekkazanFAQ',
            component: () => import('./views/FAQ/index.vue')
        },
        {
            path: '/campaignQuestions',
            name: 'campaignQuestions',
            component: () => import('./views/CampaignQuestions/CampaignQuestions.vue')
        },
        {
            path: '/contactUs',
            name: 'contactUs',
            component: () => import('./views/ContactUs/ContactUs.vue')
        },
        {
            path: '/contactUsSucceed',
            name: 'contactUsSucceed',
            component: () => import('./views/ContactUs/Succeed.vue')
        },
        {
            path: '/imageUpload',
            name: 'imageUpload',
            component: () => import('./views/CampaignQuestions/imageUpload.vue')
        },
        {
            path: '/campaignQuestionsSucceed',
            name: 'Succeed',
            component: () => import('./views/CampaignQuestions/Succeed.vue')
        },
        {
            path: '/couponSended',
            name: 'couponSended',
            component: () => import('./views/CampaignQuestions/CouponSended.vue')
        },
        {
            path: '/raffleParticipated',
            name: 'raffleParticipated',
            component: () => import('./views/CampaignQuestions/RaffleParticipated.vue')
        },
        {
            path: '/consent',
            name: 'consent',
            component: () => import('./views/Terms/index.vue')
        },
        {
            path: '/clarify',
            name: 'clarify',
            component: () => import('./views/Terms/index.vue')
        },
        {
            path: '/gdpr',
            name: 'gdpr',
            component: () => import('./views/Terms/index.vue')
        },
        {
            path: '/terms',
            name: 'terms',
            component: () => import('./views/Terms/index.vue')
        },
        {
            path: '/privacy',
            name: 'privacy',
            component: () => import('./views/Terms/index.vue')
        },
        {
            path: '/raffleCampaigns',
            name: 'raffleCampaigns',
            component: () => import('./views/RaffleWinners/index.vue')
        },
        {
            path: '/raffleCampaigns/:id',
            name: 'winners',
            component: () => import('./views/RaffleWinners/Winners.vue')
        }
    ]
});

export default router;
